import api from '../../api'
// import entites from '../../api/models/entites';
const state = {
    all:[],
    delais:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id: '',
            libelle: '',
            valeur: '',
            created_at: '',
            deleted_at: '',
            updated_at: '',
            btn:""
        }
        state.all.forEach(element => {           
            row = {
                id: element.id,
                libelle: element.libelle,
                valeur: element.valeur.toLocaleString(),
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at
            }
            data.push(row)
        });
        return data;
    },
    rows_delais(state){
        let data = []
        let type = {
            nb_jour: ''
        }
        //console.log(state.delais)
        state.delais.forEach(element => {           
            type = {
                nb_jour: element.nb_jour             
            }
            data.push(type)
        });
        return data;
    },
}
const mutations= {
    setPlafonds(state, plafonds) {
        state.all = plafonds
    },
    setDuree(state, duree) {
        state.delais = duree
    },
    addPlafonds(state,plafonds){
        state.all.push(plafonds)
    }
}

const actions={
    get_all_plafonds({ commit }){
        let tab_temp = []
        return api.plafonds.get_all_plafonds().then((response)=>{
            tab_temp.push(response.data.data)
            commit('setPlafonds', tab_temp)
            tab_temp = []
            return response.data
        })
    },
    get_delais({ commit }){
        let tab_temp=[]
        return api.plafonds.get_delais().then((response)=>{
            tab_temp.push(response.data.data)
            commit('setDuree', tab_temp)
            tab_temp=[]
            return response.data
        })
    },
    get_all_typesentite({ commit }){
        return api.entity.get_all_typesentite().then((response)=>{          
            commit('settypesentity', response.data.data)
            return response.data.data
        })
    },
    put_plafonds({ commit }, plafond){
        return api.plafonds.put_plafonds(plafond.id,plafond).then((response)=>{
            //commit('addPlafonds', response.data.data)
            return response.data
        })
        .catch(error => {
            return error.response.data
        })
    },
    post_plafonds_autorisation({ commit }, num_transactions){
        return api.plafonds.post_plafonds_autorisation(num_transactions).then((response)=>{
            return response.data
        })
        .catch(error => {
            return error.response.data
        })
    },
    post_delais({ commit }, delais){
        return api.plafonds.post_delais(delais).then((response)=>{
            commit('addPlafonds', response.data.data)
            return response.data
        })
        .catch(error => {
            return error.response.data
        })
    },
    put_delais({commit},data){
        console.log(data)
        return api.plafonds.put_delais(data.id,data.delais).then((response)=>{
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    show_entites({commit},id){
        return api.entity.show_entites(id).then((response)=>{
            return response.data.data;
        })
    },
    delete_entites({commit},id){
        return api.entity.delete_entites(id).then((response)=>{
            console.log(response.data)
            return response.data;
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
